import React from 'react';

/**
 * Create a number of line items.
 * @param {int} max 
 */
const createLines = max => {

    // Buffer for the range.
    const range = [];

    // Populate the range.
    for (let i = 1; i <= max; i++) {
        range.push(i);
    }

    // Return the line items.
    return range.map((number) => {
        return <li key={number}>{number}</li>
    });
};

/**
 * Render line number entries.
 * @param {int} numLines 
 * @param {string} height 
 */
export const renderLines = (numLines, height) => {
    return <div style={{height:height}} className="syntax__line-numbers">
        <ul>{createLines(numLines)}</ul>
    </div>
}


// WEBPACK FOOTER //
// ./src/helpers.js